import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import JobSeekerDashboard from "./pages/JobSeekerDashboard";
import RecruiterDashboard from "./pages/RecruiterDashboard";
import About from "./pages/About";
import Contact from "./pages/Contact";
import JoinWaitlist from "./pages/JoinWaitlist";
import AIAgentDevelopment from "./pages/AIAgentDevelopment";
import SOPAutomation from "./pages/SOPAutomation";
import TalentRecruitment from "./pages/TalentRecruitment";
import AITraining from "./pages/AITraining";
import TermsAndConditions from "./pages/TermsAndConditions";
import JobSeekerProfile from "./pages/profile/JobSeekerProfile";
import AgentBuilder from "./pages/AgentBuilder";
import ApprovalPage from './pages/ApprovalPage';

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/job-seeker-dashboard" element={<JobSeekerDashboard />} />
            <Route path="/job-seeker-profile" element={<JobSeekerProfile />} />
            <Route path="/recruiter-dashboard" element={<RecruiterDashboard />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/join-waitlist" element={<JoinWaitlist />} />
            <Route path="/ai-agent-development" element={<AIAgentDevelopment />} />
            <Route path="/sop-automation" element={<SOPAutomation />} />
            <Route path="/talent-recruitment" element={<TalentRecruitment />} />
            <Route path="/ai-training" element={<AITraining />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/agent-builder" element={<AgentBuilder />} />
            <Route path="/approve" element={<ApprovalPage />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
